var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contact__list-item" }, [
    _c("div", { staticClass: "contact__card" }, [
      _c("div", { staticClass: "dash-library__name contact-container" }, [
        _c("div", { staticClass: "contact__icon" }, [
          _vm.contact.hasPortalAccount
            ? _c("span", {
                staticClass: "glyphicon glyphicon-user",
                attrs: { "aria-hidden": "true" }
              })
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "contact__name" }, [
          _c("div", { staticClass: "h-bold-text" }, [
            _vm._v("\n          " + _vm._s(_vm.contact.name)),
            _vm.credentials !== ""
              ? _c("span", [_vm._v(", " + _vm._s(_vm.credentials))])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.contact.email !== ""
            ? _c("div", [_vm._v("Email: " + _vm._s(_vm.contact.email))])
            : _vm._e(),
          _vm._v(" "),
          _vm.contact.phone_number !== ""
            ? _c("div", [_vm._v("Phone: " + _vm._s(_vm.contact.phone_number))])
            : _vm._e(),
          _vm._v(" "),
          _vm.contact.mobile !== ""
            ? _c("div", [_vm._v("Mobile: " + _vm._s(_vm.contact.mobile))])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "contact__info" }, [
          _c(
            "div",
            { staticClass: "contact__access-level" },
            [
              _vm.contact.hasPortalAccount
                ? _c("Permissions", {
                    attrs: { permissions: _vm.contact.portalPermissions }
                  })
                : _c("span", [_vm._v(" ")])
            ],
            1
          ),
          _vm._v(" "),
          _vm.contact.title !== ""
            ? _c("div", [_vm._v("Title: " + _vm._s(_vm.contact.title))])
            : _vm._e(),
          _vm._v(" "),
          _vm.contact.title !== ""
            ? _c("div", [
                _vm._v("Department: " + _vm._s(_vm.contact.department))
              ])
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }